import PageIndex from '@/pages/front/pageIndex'
import PageAdmin from '@/pages/admin/pageIndex'
import PageUC from '@/pages/uc/pageIndex'
import FrontRoutes from '@/routers/front'
import AdminRoutes from '@/routers/org'
import UCRoutes from '@/routers/uc'
import PageReload from '@/pages/others/reload'
import PageNotFound from '@/pages/others/pageNotFound'
const routes = [
  {
    path: '/', // 默认路由
    component: PageIndex,
    redirect: '/home',
    children: FrontRoutes
  },
  {
    path: '/uc',
    component: PageUC,
    redirect: '/uc/record',
    children: UCRoutes
  },
  {
    path: '/org',
    component: PageAdmin,
    children: AdminRoutes
  },
  {
    path: '/reload',
    component: PageReload
  },
  {
    path: '*', // 无效路由
    redirect: '/404',
    meta: {}
  },
  {
    path: '/404',
    component: PageNotFound
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/routers/shell.js